import React from "react";
import {
    List,
    Modal,
    Picker,
    Toast,
    ImagePicker,
    InputItem,
    Button,
    Flex,
    SearchBar,
} from "antd-mobile";
import { createForm } from "rc-form";
import { post } from "../../utils/request";
import msg1 from "./img/msg1.png";
import msg2 from "./img/msg2.png";
import AMapLoader from "@amap/amap-jsapi-loader";

import "./index.less";
const Item = List.Item;
const alert = Modal.alert;
let map, marker, accidentPlacePress, longAndLatPress, local;
class CarClaimSurveyAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            code: "", //涉及场景：1.APP端填写后h5后打开(已提交)；2.APP端修改联系人电话后h5打开(失效)3.APP端删除工单(失效)；
            searchValue: "",
            carClaimId: "", //出险id
            detail: {}, //出险详情
            status: "1",
            stageDetail: {}, //出险事故暂存详情
            accidentPlace: "", //地址
            accidentPlacePress: "", //已选中
            longAndLat: "", //地点
            longAndLatPress: "", //已选中
            accidentPlaceModal: false,
            injuryLevelValue: "", //人伤等级
            injuryLevels: [], //人伤等级
            accidentTypeValue: "", //事故类型
            accidentTypes: [], //事故类型
            responsibilityValue: "", //责任划分
            responsibilitys: [], //责任划分
            accidentAccessory: { images: [], url: [] }, //事故照片
            responsibilityAccessory: { images: [], url: [] }, //事故照片
            driverLicense: { images: [], url: [] }, //事故照片
            surveyMemo: "", //查勘备注
            accidentLevels: [
                {
                    description: "轻微",
                    dictionaryCode: "S",
                    dictionaryName: "轻微",
                    label: "轻微",
                    value: "S",
                },
                {
                    description: "一般",
                    dictionaryCode: "M",
                    dictionaryName: "一般",
                    label: "一般",
                    value: "M",
                },
                {
                    description: "重大",
                    dictionaryCode: "L",
                    dictionaryName: "重大",
                    label: "重大",
                    value: "L",
                },
            ],
            injuryLevels: [
                {
                    description: "无伤害",
                    dictionaryCode: "NULL",
                    dictionaryName: "无伤害",
                    label: "无伤害",
                    value: "NULL",
                },
                {
                    description: "轻微伤害",
                    dictionaryCode: "SMALL",
                    dictionaryName: "轻微伤害",
                    label: "轻微伤害",
                    value: "SMALL",
                },
                {
                    description: "严重伤害",
                    dictionaryCode: "LARGE",
                    dictionaryName: "严重伤害",
                    label: "严重伤害",
                    value: "LARGE",
                },
            ],
            accidentTypes: [
                {
                    description: "单车事故",
                    dictionaryCode: "SINGLE",
                    dictionaryName: "单车事故",
                    label: "单车事故",
                    value: "SINGLE",
                },
                {
                    description: "双车事故",
                    dictionaryCode: "DOUBLE",
                    dictionaryName: "双车事故",
                    label: "双车事故",
                    value: "DOUBLE",
                },
                {
                    description: "多车事故",
                    dictionaryCode: "MULTI",
                    dictionaryName: "多车事故",
                    label: "多车事故",
                    value: "MULTI",
                },
            ],
            responsibilitys: [
                {
                    description: "全责",
                    dictionaryCode: "FULL",
                    dictionaryName: "全责",
                    label: "全责",
                    value: "FULL",
                },
                {
                    description: "主责",
                    dictionaryCode: "MAIN",
                    dictionaryName: "主责",
                    label: "主责",
                    value: "MAIN",
                },
                {
                    description: "同责",
                    dictionaryCode: "SHARE",
                    dictionaryName: "同责",
                    label: "同责",
                    value: "SHARE",
                },
                {
                    description: "次责",
                    dictionaryCode: "SEC",
                    dictionaryName: "次责",
                    label: "次责",
                    value: "SEC",
                },
                {
                    description: "无责",
                    dictionaryCode: "NO",
                    dictionaryName: "无责",
                    label: "无责",
                    value: "NO",
                },
            ],
        };
    }
    componentDidMount() {
        const search = window.location.hash.split("?")[1];
        if (search.indexOf("carClaimId") > -1) {
            this.setState(
                {
                    carClaimId: search.split("&")[0].split("=")[1],
                },
                () => {
                    this.selectCarClaimDetail();
                }
            );

            /**
             * selectBdDictionaryList 需要登录，所以菜单写死
             */
            // this.selectBdDictionaryList({parentDictionaryCode:'claim_accident_level'});//事故等级
            // this.selectBdDictionaryList({parentDictionaryCode:'claim_injury_level'});//人伤等级
            // this.selectBdDictionaryList({parentDictionaryCode:'claim_accident_type'});//事故类型
            // this.selectBdDictionaryList({parentDictionaryCode:'claim_responsibility'});//责任划分
        }
    }
    showModal = (key) => (e) => {
        e.preventDefault(); // 修复 Android 上点击穿透
        this.setState(
            {
                [key]: true,
            },
            () => {
                this.initMap();
            }
        );
    };
    // getAddrAccordingPoint(point) {
    //     const _this = this;
    //     return new Promise(function (resolve, reject) {
    //         new BMap.Geocoder().getLocation(point, function (result) {
    //             if (result) {
    //                 if (!!result.surroundingPois[0]) {
    //                     _this.accidentPlacePress =
    //                         result.address +
    //                         " " +
    //                         result.surroundingPois[0].title;
    //                 } else {
    //                     _this.accidentPlacePress = result.address;
    //                 }
    //                 _this.setState({
    //                     accidentPlacePress: _this.accidentPlacePress,
    //                     // longAndLatPress:_this.longAndLatPress,
    //                 });
    //                 resolve(_this.accidentPlacePress);
    //             }
    //         });
    //     });
    // }
    initMap = () => {
        AMapLoader.load({
            key: "1fb089d0886370d069de60b28db8d101", // 申请好的Web端开发者Key，首次调用 load 时必填
            version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            plugins: [
                "AMap.Geolocation",
                "AMap.Geocoder",
                "AMap.PlaceSearch",
                "AMap.AutoComplete",
            ], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        }).then((AMap) => {
            let map = new AMap.Map("allmap", {
                animateEnable: false,
                doubleClickZoom: false,
                keyboardEnable: true,
                zoom: 13,
            });
            const { longAndLat } = this.state;
            if (longAndLat) {
                const longAndLatObj = longAndLat.split(",");
                let marker = new AMap.Marker({
                    position: [longAndLatObj[0], longAndLatObj[1]],
                });
                map.add(marker);
                map.setCenter([longAndLatObj[0], longAndLatObj[1]]);
            } else {
                const geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 0,
                });
                map.addControl(geolocation);
                geolocation.getCurrentPosition((status, result) => {
                    if (status === "complete") {
                        console.log(result);
                        // alert(result.position && Array.isArray(result.position))
                        // if (result.position && typeof result.position === 'string') {
                        //     const data = result.position.split(',')
                        //     this.searchParam.lng = data[0]
                        //     this.searchParam.lat = data[1]
                        // } else if (result.position && Array.isArray(result.position)) {
                        //     this.searchParam.lng = result.position[0]
                        //     this.searchParam.lat = result.position[1]
                        // } else if (result.position && typeof result.position === 'object') {
                        //     this.searchParam.lng = result.position.getLng()
                        //     this.searchParam.lat = result.position.getLat()
                        // }
                        // map.setCenter([data.position.lng, data.position.lat]);
                    } else {
                        console.log(result);
                    }
                });
            }

            const geocoder = new AMap.Geocoder({
                // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                city: "010",
            });

            map.on("click", (e) => {
                map.clearMap();
                let lnglat = e.lnglat;
                const icon = new AMap.Icon({
                    image: "https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png",
                    imageSize: [19, 31],
                    size: [19, 31],
                    imageOffset: [0, 0],
                });
                let marker = new AMap.Marker({
                    icon,
                });
                map.add(marker);
                marker.setPosition(lnglat);

                geocoder.getAddress(lnglat, (type, res) => {
                    if (type === "complete" && res.info === "OK") {
                        const {
                            regeocode: { addressComponent, formattedAddress },
                        } = res;
                        this.accidentPlacePress = formattedAddress;

                        this.setState({
                            accidentPlacePress: formattedAddress,
                        });
                    }
                });
            });

            this.local = new AMap.PlaceSearch({
                pageSize: 5, // 单页显示结果条数
                pageIndex: 1, // 页码
                map: map, // 展现结果的地图实例
                // panel: "panel", // 结果列表将在此容器中进行展示。
                autoFitView: true, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
            });
        });
        // const _this = this;
        // var obj = {};
        // this.map.addEventListener("touchstart", function (e) {
        //     obj.e = e.changedTouches ? e.changedTouches[0] : e;
        //     obj.target = e.target;
        //     obj.time = Date.now();
        //     obj.X = obj.e.pageX;
        //     obj.Y = obj.e.pageY;
        // });
        // this.map.addEventListener("touchend", function (e) {
        //     obj.e = e.changedTouches ? e.changedTouches[0] : e;
        //     if (
        //         obj.target === e.target &&
        //         // 大于 750 可看成长按了
        //         Date.now() - obj.time < 750 &&
        //         // 应用勾股定理判断，如果 touchstart 的点到 touchend 的点小于 15，就可当成地图被点击了
        //         Math.sqrt(
        //             Math.pow(obj.X - obj.e.pageX, 2) +
        //                 Math.pow(obj.Y - obj.e.pageY, 2)
        //         ) < 15
        //     ) {
        //         // 地图被点击了，执行一些操作
        //         _this.longAndLatPress = e.point.lng + "," + e.point.lat;
        //         if (_this.marker) {
        //             _this.map.removeOverlay(_this.marker);
        //         }
        //         _this.marker = new BMap.Marker(
        //             new BMap.Point(e.point.lng, e.point.lat)
        //         );
        //         _this.map.addOverlay(_this.marker);
        //         _this.getAddrAccordingPoint(e.point);
        //     }
        // });
        // this.local = new BMap.LocalSearch(this.map, {
        //     renderOptions: { map: this.map },
        // }); // 关键字检索
    };
    closeModal = (key) => () => {
        this.setState({
            [key]: false,
        });
    };
    handleClose = (key) => () => {
        const { stageDetail, accidentPlace } = this.state;

        this.accidentPlacePress = accidentPlace || "";
        this.longAndLatPress =
            stageDetail && stageDetail.accidentPlaceLongtitude
                ? stageDetail.accidentPlaceLongtitude +
                  "," +
                  stageDetail.accidentPlaceLatitude
                : "";
        this.setState({
            [key]: false,
            accidentPlacePress: this.accidentPlacePress,
            longAndLatPress: this.longAndLatPress,
        });
    };
    handlePlace = (key) => () => {
        console.log("this.longAndLatPress==", this.longAndLatPress);
        this.setState({
            [key]: false,
            accidentPlace: this.accidentPlacePress,
            longAndLat: this.longAndLatPress,
        });
    };
    selectCarClaimDetail = () => {
        Toast.loading("加载...", 3, () => {});
        let url = "/gateway/huilian/carClaimcs/selectCarClaimDetail";
        post({
            url,
            data: {
                identity: "H5",
                carClaimId: this.state.carClaimId,
            },
        }).then(
            (res) => {
                if (res.result === "success") {
                    this.setState(
                        {
                            detail: res.data,
                            status: res.data.status,
                        },
                        () => {
                            if (res.data.status === "1") {
                                this.queryCarClaimStageDetail();
                            } else {
                                Toast.hide();
                            }
                        }
                    );
                } else {
                    Toast.hide();
                    if (res.code === "HL001320100003") {
                        this.setState({
                            code: res.code,
                            status: "2",
                        });
                    }
                }
            },
            (res) => {
                Toast.hide();
                Toast.info(res.msg, 1);
            }
        );
    };
    queryCarClaimStageDetail = () => {
        let url = "/gateway/huilian/carClaimcs/queryCarClaimStageDetail";
        const param = {
            identity: "H5",
            carClaimId: this.state.carClaimId,
        };
        if (this.state.detail.partyId) {
            param.partyId = this.state.detail.partyId;
        }

        post({ url, data: param }).then(
            (res) => {
                Toast.hide();
                const data = res.data;
                if (res.result === "success") {
                    let accidentAccessoryObj = { images: [], url: [] };
                    data &&
                        data.accidentAccessory &&
                        JSON.parse(data.accidentAccessory).map((d, i) => {
                            accidentAccessoryObj.images.push({
                                url: d.dataImg,
                            });
                            accidentAccessoryObj.url.push(d.dataImg);
                        });

                    let responsibilityAccessoryObj = { images: [], url: [] };
                    data &&
                        data.responsibilityAccessory &&
                        JSON.parse(data.responsibilityAccessory).map((d, i) => {
                            responsibilityAccessoryObj.images.push({
                                url: d.dataImg,
                            });
                            responsibilityAccessoryObj.url.push(d.dataImg);
                        });

                    let driverLicenseObj = { images: [], url: [] };
                    data &&
                        data.driverLicense &&
                        JSON.parse(data.driverLicense).map((d, i) => {
                            driverLicenseObj.images.push({ url: d.dataImg });
                            driverLicenseObj.url.push(d.dataImg);
                        });

                    this.setState({
                        stageDetail: data,
                        accidentPlace: (data && data.accidentPlace) || "",
                        accidentPlacePress: (data && data.accidentPlace) || "",
                        accidentTypeValue:
                            data && data.accidentType
                                ? [data.accidentType]
                                : [],
                        responsibilityValue:
                            data && data.responsibility
                                ? [data.responsibility]
                                : [],
                        injuryLevelValue:
                            data && data.injuryLevel ? [data.injuryLevel] : [],
                        longAndLat:
                            data && data.accidentPlaceLongtitude
                                ? data.accidentPlaceLongtitude +
                                  "," +
                                  data.accidentPlaceLatitude
                                : "",
                        surveyMemo: (data && data.surveyMemo) || "",
                        accidentAccessory: accidentAccessoryObj,
                        responsibilityAccessory: responsibilityAccessoryObj,
                        driverLicense: driverLicenseObj,
                    });
                    this.accidentPlacePress =
                        (data && data.accidentPlace) || "";
                    this.longAndLatPress =
                        data && data.accidentPlaceLongtitude
                            ? data.accidentPlaceLongtitude +
                              "," +
                              data.accidentPlaceLatitude
                            : "";
                } else {
                    Toast.info(res.msg, 1);
                }
            },
            (res) => {
                Toast.hide();
                Toast.info(res.msg, 1);
            }
        );
    };
    selectBdDictionaryList = (ops) => {
        let url =
            "/gateway/manageBedrock/bdDictionarycs/selectBdDictionaryList";
        post({ url, data: ops }).then(
            (res) => {
                res.data.map((d, i) => {
                    d.label = d.dictionaryName;
                    d.value = d.dictionaryCode;
                });
                if (ops.parentDictionaryCode == "claim_accident_level") {
                    //出险事故等级
                    this.setState({
                        accidentLevels: res.data,
                    });
                } else if (ops.parentDictionaryCode == "claim_injury_level") {
                    //人伤等级
                    this.setState({
                        injuryLevels: res.data,
                    });
                } else if (ops.parentDictionaryCode == "claim_accident_type") {
                    //事故类型
                    this.setState({
                        accidentTypes: res.data,
                    });
                } else if (ops.parentDictionaryCode == "claim_responsibility") {
                    //责任划分
                    this.setState({
                        responsibilitys: res.data,
                    });
                }
            },
            (res) => {
                this.setState({
                    setDataType: false,
                });
            }
        );
    };
    onChangeInjuryLevel = (item) => {
        this.setState({
            injuryLevelValue: item,
        });
    };
    onChangeAccidentType = (item) => {
        this.setState({
            accidentTypeValue: item,
        });
    };
    onChangeResponsibility = (item) => {
        this.setState({
            responsibilityValue: item,
        });
    };
    onChangeImages = (key, files, type, index) => {
        const url = "/gateway/huilianApi/uploader/attachment";
        let data = this.state[key];
        if (type === "add") {
            let file = [];
            let filesB = files.slice();
            var num = files.length - data.images.length;
            var filesC = filesB.splice(data.images.length, num);
            file = filesC.map((item) => {
                return item.file;
            });

            Toast.loading("图片上传中...", 300, () => {
                console.log("Load complete !!!");
            });
            post({
                url,
                headers: {
                    "Content-Type": "multipart/form-data;",
                },
                data: {
                    attachmenType: "IMGS",
                    file,
                },
            }).then(
                (res) => {
                    Toast.hide();
                    if (res.result === "success" && res.data) {
                        res.data.map((item) => {
                            data.url.push(item.attachmenturl);
                        });
                        data.images = files;
                        this.setState({
                            [key]: data,
                        });
                    } else {
                        Toast.info(res.msg, 1);
                    }
                },
                (res) => {
                    Toast.hide();
                    Toast.info(res.msg, 1);
                }
            );
        }

        if (type === "remove") {
            data.images = files;
            data.url.splice(index, 1);
            this.setState({
                [key]: data,
            });
        }
    };
    updata(key, val) {
        let data = this.state;
        data[key] = val;
        this.setState({
            data,
        });
    }
    validateForm = () => {
        const {
            detail,
            accidentPlace,
            accidentTypeValue,
            injuryLevelValue,
            responsibilityValue,
            accidentAccessory,
            responsibilityAccessory,
            driverLicense,
        } = this.state;
        let validate = true;
        if (validate && !accidentPlace) {
            Toast.info("请选择事故地点", 1);
            validate = false;
        }
        if (validate && !accidentTypeValue) {
            Toast.info("请选择事故类型", 1);
            validate = false;
        }
        if (validate && !injuryLevelValue) {
            Toast.info("请选择人伤等级", 1);
            validate = false;
        }
        if (validate && !responsibilityValue) {
            Toast.info("请选择责任划分", 1);
            validate = false;
        }
        if (validate && !accidentAccessory.url.length) {
            Toast.info("请上传事故照片", 1);
            validate = false;
        }
        if (validate && !responsibilityAccessory.url.length) {
            Toast.info("请上传责任认定书", 1);
            validate = false;
        }
        // if(validate && !driverLicense.url.length){
        //     Toast.info('请上传驾驶证照片',1);
        //     validate = false;
        // }
        return validate;
    };
    stageCarClaimSurvey() {
        const {
            detail,
            accidentPlace,
            longAndLat,
            accidentTypeValue,
            injuryLevelValue,
            responsibilityValue,
            accidentAccessory,
            responsibilityAccessory,
            driverLicense,
            surveyMemo,
        } = this.state;
        let accidentAccessoryObj = [];
        accidentAccessory.url.map((d, i) => {
            accidentAccessoryObj.push({
                dataImg: d,
                imgName: "事故照片" + Number(i + 1),
            });
        });
        let responsibilityAccessoryObj = [];
        responsibilityAccessory.url.map((d, i) => {
            responsibilityAccessoryObj.push({
                dataImg: d,
                imgName: "责任认定书" + Number(i + 1),
            });
        });
        let driverLicenseObj = [];
        driverLicense.url.map((d, i) => {
            driverLicenseObj.push({
                dataImg: d,
                imgName: "驾驶证照片" + Number(i + 1),
            });
        });
        let url = "/gateway/huilian/carClaimcs/stageCarClaimSurvey";
        post({
            url,
            data: {
                identity: "H5",
                carClaimId: detail.carClaimId,
                accidentPlace: accidentPlace,
                accidentPlaceLongtitude: longAndLat
                    ? longAndLat.split(",")[0]
                    : "",
                accidentPlaceLatitude: longAndLat
                    ? longAndLat.split(",")[1]
                    : "",
                accidentType: accidentTypeValue.length
                    ? accidentTypeValue[0]
                    : "",
                injuryLevel: injuryLevelValue.length ? injuryLevelValue[0] : "",
                responsibility: responsibilityValue
                    ? responsibilityValue[0]
                    : "",
                accidentAccessory: accidentAccessoryObj.length
                    ? JSON.stringify(accidentAccessoryObj)
                    : "",
                responsibilityAccessory: responsibilityAccessoryObj.length
                    ? JSON.stringify(responsibilityAccessoryObj)
                    : "",
                driverLicense: driverLicenseObj.length
                    ? JSON.stringify(driverLicenseObj)
                    : "",
                surveyMemo: surveyMemo,
            },
        }).then(
            (res) => {
                if (res.result === "success") {
                } else {
                    if (res.code === "HL001320100003") {
                        //已经提交
                        this.setState({
                            code: res.code,
                            status: "2",
                        });
                    }
                }
                Toast.info(res.msg, 1);
            },
            (res) => {
                Toast.info(res.msg, 1);
            }
        );
    }
    surveyCarClaim() {
        const {
            detail,
            accidentPlace,
            longAndLat,
            accidentTypeValue,
            injuryLevelValue,
            responsibilityValue,
            accidentAccessory,
            responsibilityAccessory,
            driverLicense,
            surveyMemo,
        } = this.state;
        let accidentAccessoryObj = [];
        accidentAccessory.url.map((d, i) => {
            accidentAccessoryObj.push({
                dataImg: d,
                imgName: "事故照片" + Number(i + 1),
            });
        });

        let responsibilityAccessoryObj = [];
        responsibilityAccessory.url.map((d, i) => {
            responsibilityAccessoryObj.push({
                dataImg: d,
                imgName: "责任认定书" + Number(i + 1),
            });
        });
        let driverLicenseObj = [];
        driverLicense.url.map((d, i) => {
            driverLicenseObj.push({
                dataImg: d,
                imgName: "驾驶证照片" + Number(i + 1),
            });
        });

        let url = "/gateway/huilian/carClaimcs/surveyCarClaim";
        const param = {
            identity: "H5",
            carClaimId: detail.carClaimId,
            accidentPlace: accidentPlace,
            accidentPlaceLongtitude: longAndLat ? longAndLat.split(",")[0] : "",
            accidentPlaceLatitude: longAndLat ? longAndLat.split(",")[1] : "",
            accidentType: accidentTypeValue.length ? accidentTypeValue[0] : "",
            injuryLevel: injuryLevelValue.length ? injuryLevelValue[0] : "",
            responsibility: responsibilityValue ? responsibilityValue[0] : "",
            accidentAccessory: accidentAccessoryObj.length
                ? JSON.stringify(accidentAccessoryObj)
                : "",
            responsibilityAccessory: responsibilityAccessoryObj.length
                ? JSON.stringify(responsibilityAccessoryObj)
                : "",
            driverLicense: driverLicenseObj.length
                ? JSON.stringify(driverLicenseObj)
                : "",
            surveyMemo: surveyMemo,
            partyId: detail.partyId || "",
            customerName: detail.customerName || "",
        };

        post({ url, data: param }).then(
            (res) => {
                this.setState({
                    code: res.code,
                    status: "2",
                });

                Toast.info(res.msg, 1);
            },
            (res) => {
                Toast.info(res.msg, 1);
            }
        );
    }
    handleSearch = (value) => {
        this.local.search(value);
    };
    onChangeValue = (value) => {
        this.setState({
            searchValue: value,
        });
    };
    render() {
        const {
            code,
            detail,
            status,
            searchValue,
            accidentPlace, //保存地址
            accidentPlacePress, //已选中
            accidentPlaceModal,
            injuryLevelValue,
            injuryLevels,
            accidentTypeValue,
            accidentTypes,
            responsibilityValue,
            responsibilitys,
            accidentAccessory,
            responsibilityAccessory,
            driverLicense,
            surveyMemo,
        } = this.state;

        return (
            <div className="carClaimSurveyAdd">
                {status === "1" ? (
                    <div>
                        <div className="carClaimSurveyAdd-head">
                            <h1>
                                {detail.carPlateNumber}
                                <span>{detail.carType}</span>
                            </h1>
                            <p>
                                事故时间：
                                {detail.claimDate
                                    ? detail.claimDate.slice(0, 16)
                                    : ""}
                            </p>
                            <p>
                                报案人信息：{detail.reporter}&nbsp;&nbsp;
                                {detail.reporterMobile}
                            </p>
                            <p>事故描述：{detail.descript}</p>
                        </div>
                        <div className="carClaimSurveyAdd-content">
                            <List>
                                <div className="picker-wrap">
                                    <Item
                                        extra={
                                            accidentPlace ||
                                            "请选择事故发生地点"
                                        }
                                        arrow="horizontal"
                                        onClick={this.showModal(
                                            "accidentPlaceModal"
                                        )}
                                    >
                                        事故地点
                                    </Item>
                                </div>
                                <div className="picker-wrap">
                                    <Picker
                                        data={accidentTypes}
                                        value={accidentTypeValue}
                                        cols={1}
                                        onChange={this.onChangeAccidentType}
                                    >
                                        <Item arrow="horizontal">事故类型</Item>
                                    </Picker>
                                </div>
                                <div className="picker-wrap">
                                    <Picker
                                        data={injuryLevels}
                                        value={injuryLevelValue}
                                        cols={1}
                                        onChange={this.onChangeInjuryLevel}
                                    >
                                        <Item arrow="horizontal">人伤等级</Item>
                                    </Picker>
                                </div>

                                <div className="picker-wrap">
                                    <Picker
                                        data={responsibilitys}
                                        value={responsibilityValue}
                                        cols={1}
                                        onChange={this.onChangeResponsibility}
                                    >
                                        <Item arrow="horizontal">责任划分</Item>
                                    </Picker>
                                </div>
                                <Item>
                                    <div className="image-label-box">
                                        <span className="image-label">
                                            事故照片
                                        </span>
                                    </div>
                                    <span style={{ color: "#c5c5c5" }}>
                                        上传事故前景、近景及损伤处照片等，必填
                                    </span>
                                    <div className="file-imgs-box">
                                        <ImagePicker
                                            length="5"
                                            selectable={
                                                accidentAccessory.images
                                                    .length < 10
                                            }
                                            onChange={(files, type) => {
                                                if (files.length > 10) {
                                                    Toast.info(
                                                        "图片数量不能大于10张",
                                                        1
                                                    );
                                                    return;
                                                }
                                                this.onChangeImages(
                                                    "accidentAccessory",
                                                    files,
                                                    type
                                                );
                                            }}
                                            files={accidentAccessory.images}
                                            multiple={true}
                                        />
                                    </div>
                                </Item>
                                <Item>
                                    <div className="image-label-box">
                                        <span className="image-label">
                                            责任认定书
                                        </span>
                                    </div>
                                    <span style={{ color: "#c5c5c5" }}>
                                        上传责任认定书，必填
                                    </span>
                                    <div className="file-imgs-box">
                                        <ImagePicker
                                            length="5"
                                            selectable={
                                                responsibilityAccessory.images
                                                    .length < 2
                                            }
                                            onChange={(files, type) => {
                                                if (files.length > 2) {
                                                    Toast.info(
                                                        "图片数量不能大于2张",
                                                        1
                                                    );
                                                    return;
                                                }
                                                this.onChangeImages(
                                                    "responsibilityAccessory",
                                                    files,
                                                    type
                                                );
                                            }}
                                            files={
                                                responsibilityAccessory.images
                                            }
                                            multiple={true}
                                        />
                                    </div>
                                </Item>
                                <Item>
                                    <div className="image-label-box">
                                        <span className="image-label">
                                            驾驶证照片
                                        </span>
                                    </div>
                                    <span style={{ color: "#c5c5c5" }}>
                                        上传驾驶证正本和副本照片，非必填
                                    </span>
                                    <div className="file-imgs-box">
                                        <ImagePicker
                                            length="5"
                                            selectable={
                                                driverLicense.images.length < 2
                                            }
                                            onChange={(files, type) => {
                                                if (files.length > 2) {
                                                    Toast.info(
                                                        "图片数量不能大于2张",
                                                        1
                                                    );
                                                    return;
                                                }
                                                this.onChangeImages(
                                                    "driverLicense",
                                                    files,
                                                    type
                                                );
                                            }}
                                            files={driverLicense.images}
                                            multiple={true}
                                        />
                                    </div>
                                </Item>
                                <InputItem
                                    placeholder="请描述事故概况，非必填"
                                    clear
                                    labelNumber={5}
                                    value={surveyMemo}
                                    onChange={(val) => {
                                        this.updata("surveyMemo", val);
                                    }}
                                >
                                    查勘备注
                                </InputItem>
                            </List>
                            <Flex className="btn-box">
                                <Flex.Item>
                                    <Button
                                        type="ghost"
                                        inline
                                        onClick={() => {
                                            this.stageCarClaimSurvey();
                                        }}
                                    >
                                        &nbsp;暂存&nbsp;
                                    </Button>
                                </Flex.Item>
                                <Flex.Item>
                                    <Button
                                        type="primary"
                                        inline
                                        onClick={() => {
                                            this.validateForm()
                                                ? alert(
                                                      "",
                                                      "提交后不可修改，是否确认提交上述事故信息？",
                                                      [
                                                          {
                                                              text: "取消",
                                                              onPress: () =>
                                                                  console.log(
                                                                      "cancel"
                                                                  ),
                                                          },
                                                          {
                                                              text: "确认",
                                                              onPress: () => {
                                                                  this.surveyCarClaim();
                                                              },
                                                          },
                                                      ]
                                                  )
                                                : "";
                                        }}
                                    >
                                        提交事故查勘
                                    </Button>
                                </Flex.Item>
                            </Flex>
                        </div>
                        <Modal
                            className="map-wrap"
                            visible={accidentPlaceModal}
                            transparent
                            maskClosable={true}
                            onClose={this.closeModal("accidentPlaceModal")}
                            title="事故发生地点"
                            footer={[
                                {
                                    text: "取消",
                                    onPress: () => {
                                        this.handleClose(
                                            "accidentPlaceModal"
                                        )();
                                        // this.closeModal('accidentPlaceModal')();
                                    },
                                },
                                {
                                    text: "确认",
                                    onPress: () => {
                                        if (!this.accidentPlacePress) {
                                            Toast.info("请选择事故发生地点", 1);
                                            return;
                                        }
                                        this.handlePlace(
                                            "accidentPlaceModal"
                                        )();
                                    },
                                },
                            ]}
                        >
                            <SearchBar
                                value={searchValue}
                                placeholder=""
                                onSubmit={this.handleSearch}
                                onClear={(value) =>
                                    console.log(value, "onClear")
                                }
                                showCancelButton
                                onChange={this.onChangeValue}
                            />
                            <div
                                id="allmap"
                                className="map-box"
                            ></div>
                            <div className="map-address">
                                已选中：{accidentPlacePress}
                            </div>
                        </Modal>
                    </div>
                ) : code === "HL001000000000" ? (
                    <div className="carClaimSurveyAdd-result">
                        <img
                            src={msg2}
                            className="spe am-icon am-icon-md"
                            alt=""
                        />
                        <p>提交成功，感谢您的反馈，我们将尽快处理！</p>
                    </div>
                ) : code === "HL001320100006" ? (
                    <div className="carClaimSurveyAdd-result">
                        <img
                            src={msg1}
                            className="spe am-icon am-icon-md"
                            alt=""
                        />
                        <p>该项事故信息发生变更，暂无法自助上传查勘信息</p>
                    </div>
                ) : (
                    <div className="carClaimSurveyAdd-result">
                        <img
                            src={msg1}
                            className="spe am-icon am-icon-md"
                            alt=""
                        />
                        <p>慧联工作人员已提交事故查勘信息，无需重复提交</p>
                    </div>
                )}
            </div>
        );
    }
}
const CarClaimSurveyAddWrapper = createForm()(CarClaimSurveyAdd);
export default CarClaimSurveyAddWrapper;



// WEBPACK FOOTER //
// ./src/carClaimSurvey/add/index.js